(() => {
  const footer = document.querySelector('.g03');

  if (footer === null) {
    return;
  }

  const backToTop = footer.querySelector('.g03__back-to-top');
  if (backToTop !== null) {
    backToTop.addEventListener('click', () => {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    });
  }

  // Scroll to the top of the page if already on homepage.
  const logoLink = footer.querySelector('.g03__logo');
  if (document.body.classList.contains('home')) {
    logoLink.addEventListener('click', e => {
      e.preventDefault();
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    });
  }
})();